import styles from "./ReadOnlyParameterContainer.module.scss";

function ReadOnlyParameterContainer({ children }) {

  return (
    <div className={styles["container"]}>
      <div className={styles["container-default"]}>{children}</div>
    </div>
  );
}

export default ReadOnlyParameterContainer;
